/* ============
 * Supplier Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentproductFlow: [],
  orders: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productFlow/state.js